const getModelTranslationValue = (modelsTranslations, objectId) =>
  modelsTranslations?.find(({ object_id }) => object_id === objectId)
    ?.translated_value;

export default getModelTranslationValue;
